import { nodeListToArray } from './nodelist-to-array'
import { hideElements } from './hide-elements'
import { showElements } from './show-elements'

declare const TNEW_RESOURCES_DOMAIN;

function xhrRequest(url: string, requestType: string, successFunction?: Function, errorFunction?: Function) {
    let xhttp = new XMLHttpRequest();
    xhttp.withCredentials = true;
    xhttp.onreadystatechange = () => {
        if (xhttp.readyState == 4 && xhttp.status == 200) {
            //success!
            if (successFunction) {
                if (requestType === "POST")
                    successFunction(xhttp.responseURL);
                else
                    successFunction(xhttp.responseText);
            }
        }
        else {
            if (errorFunction) {
                errorFunction();
            }
        }
    };
    xhttp.open(requestType, url, true);
    if (requestType === "POST")
        xhttp.setRequestHeader('Content-Type', 'text/html');
    else
        xhttp.setRequestHeader('accept', 'application/json');
    xhttp.send();
}

export function loginState() {
    let loginStateRequestSuccess = function (responseText) {
        let isLoggedIn = JSON.parse(responseText);
        let loggedOutLinks = nodeListToArray<HTMLElement>(document.querySelectorAll('.nav-utility-loggedout-js'));
        let loggedInLinks = nodeListToArray<HTMLElement>(document.querySelectorAll('.nav-utility-loggedin-js'));
        let linksToHide = loggedInLinks;
        let linksToShow = loggedOutLinks;
        let tnewPage = document.querySelector(".tnew");

        if (isLoggedIn) {
            linksToHide = loggedOutLinks;
            linksToShow = loggedInLinks;
        }

        hideElements(linksToHide);
        showElements(linksToShow);
    }
    xhrRequest(TNEW_RESOURCES_DOMAIN + '/api/login/IsLoggedIn', "GET", loginStateRequestSuccess);
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/login-state.ts